"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ko = __importStar(require("knockout"));
const CalendarViewModelsFactory_1 = require("./factory/CalendarViewModelsFactory");
const ViewModelHelper_1 = __importDefault(require("../../utility/ViewModelHelper"));
const CalendarCommonUtilities_1 = __importDefault(require("../../utility/CalendarCommonUtilities"));
class CalendarViewModel {
    constructor(stringsProvider, calendarJson, configuration, selectedSlotIds, events, calendarModelId) {
        this.previousSlotIndexOfPreferences = [];
        this.id = calendarModelId;
        this.configuration = configuration;
        this.stringsProvider = stringsProvider;
        this.viewModelFactory = new CalendarViewModelsFactory_1.CalendarViewModelFactory(this, this.configuration, this.stringsProvider);
        this.sectionDays = this.viewModelFactory.createModel('sectionDays', null);
        this.sectionSlots = this.viewModelFactory.createModel('sectionSlots', null);
        this.visibleDayStartIndex = ko.observable(0).extend({ deferred: true });
        this.selectedDayIndex = ko.observable(-1).extend({ deferred: true });
        this.visibleWeekStartIndex = ko.observable(0).extend({ deferred: true });
        this.enabledWeekStartIndex = ko.observable(0).extend({ deferred: true });
        this.enabledWeekEndIndex = ko.observable(0).extend({ deferred: true });
        this.selectedSlotIndexes = ko.observableArray().extend({ deferred: true });
        this.days = ko.observableArray().extend({ deferred: true });
        this.slots = ko.observableArray().extend({ deferred: true });
        this.months = ko.observableArray().extend({ deferred: true });
        this.weeks = ko.observableArray().extend({ deferred: true });
        this.weekDayNames = ko.observableArray().extend({ deferred: true });
        this.calendarEvents = events;
        this.loadCalendar(calendarJson, selectedSlotIds, calendarModelId);
    }
    slotIndexOfPreferences() {
        let slotIndexOfPreferences = this.previousSlotIndexOfPreferences;
        let nextSlotIndexOfPreferences = Array.apply(null, Array(this.configuration.numOfSelection)).map(function () {
            return null;
        });
        let selectedSlotIndexes = this.selectedSlotIndexes().slice(0);
        // populate existing slot preferences of slots into nextSlotSelectionsByPreference
        for (let counter = 0, slotSelectionNum = selectedSlotIndexes.length; counter < slotSelectionNum; counter++) {
            const slotIndex = slotIndexOfPreferences.indexOf(selectedSlotIndexes[counter]);
            if (slotIndex !== -1) {
                nextSlotIndexOfPreferences[slotIndex] = selectedSlotIndexes[counter];
                selectedSlotIndexes[counter] = null;
            }
        }
        // for new slot selections get prefereces based on first avialability in nextSlotSelectionsByPreference
        for (let counter = 0, slotSelectionNum = selectedSlotIndexes.length; counter < slotSelectionNum; counter++) {
            if (selectedSlotIndexes[counter] !== null) {
                nextSlotIndexOfPreferences[nextSlotIndexOfPreferences.indexOf(null)] = selectedSlotIndexes[counter];
            }
        }
        this.previousSlotIndexOfPreferences = nextSlotIndexOfPreferences;
        return nextSlotIndexOfPreferences;
    }
    // Used when we have a previously selected slot and need to trigger a select() event
    retriggerSelectedSlotEvents() {
        let dayModel;
        ko.utils.arrayForEach(this.selectedSlotIndexes(), function (slotIndex) {
            if (slotIndex !== undefined && slotIndex > -1) {
                let slot = this.slots()[slotIndex];
                if (slot !== undefined) {
                    slot.select();
                    if (!dayModel) {
                        dayModel = this.days()[slot.dayIndex];
                    }
                    this.preselectedSlotIndexes = [];
                }
            }
        });
        if (dayModel !== undefined) {
            this.visibleWeekStartIndex(dayModel.weekIndex);
            this.selectedDayIndex(dayModel.dayIndex);
        }
    }
    ;
    selectDate(dateId) {
        let dayModels = this.days();
        let dayIndex = CalendarCommonUtilities_1.default.findWhere(dayModels, 'dateId', dateId);
        let noOfDayBoxes;
        let dateWindowStartIndex;
        let dateWindowSize = this.configuration.dateWindowSize;
        // do nothing if input dateId is not valid
        if (dayIndex !== -1) {
            noOfDayBoxes = dayModels.length;
            dayModels[dayIndex].select();
            // update visible date start index
            dateWindowStartIndex = dayIndex - (dayIndex % dateWindowSize);
            // if it's last window then make sure that window should have max possible dates
            if ((dateWindowStartIndex + dateWindowSize) > noOfDayBoxes) {
                this.visibleDayStartIndex(noOfDayBoxes - dateWindowSize);
            }
            else {
                this.visibleDayStartIndex(dateWindowStartIndex);
            }
            this.visibleWeekStartIndex(dayModels[dayIndex].weekIndex);
        }
    }
    // methods for selection or deSelection of slot box based on given slotId
    selectSlot(slotId) {
        let slotIndex = CalendarCommonUtilities_1.default.findWhere(this.slots(), 'slotId', slotId);
        // do nothing if either the slotId is invalid or the slot is already selected
        if (slotIndex !== -1 && !this.slots()[slotIndex]._isSelected()) {
            this.slots()[slotIndex].select();
        }
    }
    deselectSlot(slotId) {
        let slotIndex = CalendarCommonUtilities_1.default.findWhere(this.slots(), 'slotId', slotId);
        // do nothing if either the slotId is invalid or slot is already deSelected
        if (slotIndex !== -1 && this.slots()[slotIndex]._isSelected()) {
            this.slots()[slotIndex].select();
        }
    }
    getHeader() {
        return this.stringsProvider.getString(this.id + ':header');
    }
    getSlotDurationMessage() {
        return this.stringsProvider.getString(this.id + ':sub-header');
    }
    _resetObservables() {
        this.days.removeAll();
        this.slots.removeAll();
        this.weeks.removeAll();
        this.months.removeAll();
        this.weekDayNames.removeAll();
        this.selectedSlotIndexes.removeAll();
        this.weekDayNames.removeAll();
        this.sectionSlots.renderedSlots([]);
        this.sectionSlots.activeSlot(null);
    }
    loadCalendar(calendarJson, selectedSlotIds, calendarModelId) {
        this._resetObservables();
        const viewModelsMap = ViewModelHelper_1.default.getViewModels(calendarJson, this.viewModelFactory);
        const selectedSlotIndexes = this._getSelectedSlotIndexes(viewModelsMap.slots, selectedSlotIds || []);
        const startAndEndDays = this._getEnabledStartAndEndDayVModel(viewModelsMap.days);
        this.days(viewModelsMap.days);
        this.slots(viewModelsMap.slots);
        this.weeks(viewModelsMap.weeks);
        this.id = calendarModelId;
        this.enabledWeekStartIndex(startAndEndDays.start.weekIndex);
        this.visibleWeekStartIndex(startAndEndDays.start.weekIndex);
        this.enabledWeekEndIndex(startAndEndDays.end.weekIndex);
        this.visibleDayStartIndex(startAndEndDays.start.dayIndex);
        this.selectedDayIndex(startAndEndDays.start.dayIndex);
        this.selectedSlotIndexes(selectedSlotIndexes);
        this.weekDayNames(viewModelsMap.weekDayNames);
        this.preselectedSlotIndexes = selectedSlotIndexes.slice(0);
        this.monthViewModels = viewModelsMap.months;
    }
    _getSelectedSlotIndexes(slotVModels, selectedSlotIds) {
        let selectedSlotIndexes = [];
        let selectedSlotIdsLength = selectedSlotIds.length;
        if (!selectedSlotIdsLength) {
            return selectedSlotIndexes;
        }
        for (let slotIndex = 0; slotIndex < slotVModels.length; slotIndex++) {
            let slotVModel = slotVModels[slotIndex];
            if (selectedSlotIds.indexOf(slotVModel.slotId) !== -1) {
                selectedSlotIndexes.push(slotIndex);
                if (selectedSlotIdsLength === selectedSlotIndexes.length) {
                    break;
                }
            }
        }
        return selectedSlotIndexes;
    }
    _getEnabledStartAndEndDayVModel(dayViewModels) {
        let startDayViewModel;
        let endDayViewModel;
        for (let index = 0; index < dayViewModels.length; index++) {
            let dayViewModel = dayViewModels[index];
            if (dayViewModel.enabled && typeof startDayViewModel === 'undefined') {
                startDayViewModel = dayViewModel;
            }
            if (dayViewModel.enabled) {
                endDayViewModel = dayViewModel;
            }
        }
        return {
            start: startDayViewModel,
            end: endDayViewModel
        };
    }
}
exports.default = CalendarViewModel;
